unit DepartmentItemType;
{

/* Initail. */

}
interface

uses
  JS,
  SysUtils,
  LocationItemListType;

type
  TDepartmentItemType = class
  private
    fDepartmentKey: String;
    fName: String;
    fAmount: Word;
    fLocationItemList: TLocationItemListType;
    fActive: Boolean;
  public
    property DepartmentKey: String read fDepartmentKey;
    property Name: String read fName;
    property Amount: Word read fAmount;
    property LocationItemArray: TLocationItemListType read fLocationItemList;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TDepartmentItemType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fDepartmentKey := String(JSObject_Type['departmentKey']);
    fName := String(JSObject_Type['name']);
    fAmount := StrToIntDef(String(JSObject_Type['fAmount']), 0);
    fLocationItemList := TLocationItemListType.Create(TJSJSON.stringify(JSObject_Type['locationItemList']));
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
